module.exports = __webpack_public_path__ + "static/media/property-management-articles.06d23cd6.jpg";